import { render, staticRenderFns } from "./delete-orderable-modal.vue?vue&type=template&id=5ba90718&lang=pug"
import script from "./delete-orderable-modal.vue?vue&type=script&lang=js"
export * from "./delete-orderable-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports